<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-row justify-between items-center mb-3">
    <div class="flex flex-row md:gap-3 items-center">
      <div class="flex flex-row flex-nowrap md:gap-3 items-center">
        <!-- <img class="left-arrow" src="../../../../assets/icons/left-arrow.svg"> -->
        <h1 class="headeradminui-text md:break-keep">
          Manage Therapist Ratings
        </h1>
      </div>
      <div>
        <img
          class="separator"
          src="../../../../assets/icons/separator.svg"
          alt="Separator"
        />
      </div>
      <div>
        <h1 class="sub-headeradminui-text">{{ totalCount }} Total Ratings</h1>
      </div>
    </div>
    <!-- <div
    class="flex flex-row justify-between btn custom-btn-primary-adminui gap-1"
    [routerLink]="['/therapist/add']"
  >
    <div>
      <img class="add-icon" src="../../../../assets/icons/add-icon.svg" />
    </div>
    <div>
      <span class="">Add new therapist</span>
    </div>
  </div> -->
  </div>
  <div class="flex justify-end items-center">
    <div nz-col class="p-1">
      <nz-range-picker
        nzSize="large"
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="dateRange"
        (ngModelChange)="dateChange($event)"
      ></nz-range-picker>
    </div>
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for therapist,user name"
        />
      </nz-input-group>
    </div>
  </div>
  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="searchGlobal()"
    >
      Search
    </button>
  </ng-template>
  <ng-template #tableHead>
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <span class="font-bold">Therapists Rating</span>
      </div>
      <div nz-col class="m-1"></div>
      <div nz-col class="flex gap-2 items-center">
        <nz-switch
          [(ngModel)]="testTherapistDisplay"
          (ngModelChange)="testTherapistChangeFn($event)"
          nzCheckedChildren="Hide Test Therapist"
          nzUnCheckedChildren="Show Test Therapist"
        ></nz-switch>
        <button
          class="btn-color"
          (click)="exportDataFn()"
          nz-button
          nzSize="small"
          nzType="primary"
        >
          <span nz-icon nzType="download"></span>
          Export
        </button>
        <button
          class="ml-2"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="resetFilter()"
        >
          Clear filter
        </button>
      </div>
    </div>
  </ng-template>
  <nz-spin [nzSpinning]="pageLoading" nzTip="Fetching Therapists Rating......">
    <nz-table
      #therapistTable
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzData]="data"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalCount"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="currentPageNo"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>User Name</th>
          <th nzWidth="10%">
            Partner
            <nz-filter-trigger
              [nzActive]="true"
              [nzDropdownMenu]="partnerNameSearch"
            >
              <span nz-icon nzType="search"></span>
            </nz-filter-trigger>
          </th>
          <th>
            Plan Name
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="planMenu">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th
            (nzSortOrderChange)="sortTherapistRating($event)"
            nzShowSort="true"
          >
            Rating
          </th>
          <th>
            Concern
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="concernMenu">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th nzCustomFilter>
            Vertical
            <nz-filter-trigger
              [nzActive]="true"
              [nzDropdownMenu]="verticalMenu"
            >
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th>
            Therapists
            <nz-filter-trigger
              [nzActive]="true"
              [nzDropdownMenu]="therapistMenu"
            >
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th (nzSortOrderChange)="sortCreatedAt($event)" nzShowSort="true">
            Created At
          </th>
          <th nzWidth="30%">Questionaire</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of therapistTable.data">
          <td>
            {{ data.userName }}
          </td>
          <td>{{ data.partnerName }}</td>
          <td>
            {{ data.planName ? data.planName : "N/A" }}
          </td>
          <td>
            {{ data.rating }}
          </td>
          <td>
            {{ data.concern }}
          </td>
          <td>
            {{ data.vertical }}
          </td>
          <td>
            {{ data.therapistName }}
          </td>
          <td>
            {{ utils.convertEpochToFormattedDate(data.createdAt) }}
          </td>
          <td>
            <ng-container
              *ngIf="
                data.questionnaire && objectKeys(data.questionnaire).length > 0;
                else noData
              "
            >
              <div class="font-bold">Question - Answer :</div>
              <div *ngFor="let entry of data.questionnaire | keyvalue">
                <strong>{{ entry.key }}</strong> - {{ entry.value }}
              </div>
            </ng-container>
            <ng-template #noData> N/A </ng-template>
          </td>
        </tr>

        <tr></tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>
<nz-dropdown-menu #planMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Plans</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="planFilter($event)">
          <div *ngFor="let status of planCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="status.value"
                [ngModel]="status.checked"
                >{{ status.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #therapistMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Therapists</span>
        <nz-divider></nz-divider>
        <div class="h-96 overflow-y-scroll py-2">
          <nz-checkbox-wrapper (nzOnChange)="therapistFilter($event)">
            <div *ngFor="let status of therapistCheckBoxOptions" nz-row>
              <div nz-col>
                <label
                  nz-checkbox
                  [nzValue]="status.value"
                  [ngModel]="status.checked"
                  >{{ status.label }}</label
                >
              </div>
            </div>
          </nz-checkbox-wrapper>
        </div>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #verticalMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Verticals</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="verticalFilter($event)">
          <div *ngFor="let status of verticalCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="status.value"
                [ngModel]="status.checked"
                >{{ status.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #concernMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Concerns</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="concernFilter($event)">
          <div *ngFor="let status of concernCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="status.value"
                [ngModel]="status.checked"
                >{{ status.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #partnerNameSearch="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="partnerNameColumnSearch"
          nz-input
          placeholder="Search"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="partnerEmailSearchFn()"
        >
          Ok
        </button>
        <button
          class="m-1"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
